<ng-container *ngIf="isRPC">
  <section class="section-wrapper-neutral replacement">
    <section>
      <p>
        {{ 'MMR.REPLACEMENT.CONTENT' | translate }}
      </p>
    </section>
    <section class="item-list-wrapper">
      <p>
        {{ 'MMR.REPLACEMENT.LIST.HEADER' | translate }}
      </p>
      <ul class="item-list">
        <li>{{ 'MMR.REPLACEMENT.LIST.POINT1' | translate }}</li>
        <li>{{ 'MMR.REPLACEMENT.LIST.POINT2' | translate }}</li>
        <li>{{ 'MMR.REPLACEMENT.LIST.POINT3' | translate }}</li>
      </ul>
    </section>
  </section>
</ng-container>

<ng-container *ngIf="!isRPC">
  <ng-container
    *ngIf="calculatedAction === repairActionEnum.UNKNOWN; else StandardStates"
    [ngTemplateOutlet]="callUs"
    [ngTemplateOutletContext]="{ alternative: true }"
  >
  </ng-container>

  <ng-template #StandardStates>
    <ng-container *ngIf="item.code !== 'X7'">
      <section
        *ngIf="
          calculatedAction !== 'IN_WARRANTY' ||
          (claimType === 'REPAIR' && calculatedAction === 'IN_WARRANTY')
        "
        class="claim-status-wrapper"
        [class.claim-status-wrapper--no-box]="
          claimDetails?.isTvRemoteReplacement &&
          calculatedAction !== repairActionEnum.INCOMPLETE_FORM &&
          calculatedAction !== repairActionEnum.BOOK_ENGINEER &&
          calculatedAction !== serviceActionEnum.AMEND_SERVICE
        "
      >
        <section *ngIf="claimDisplayDetails.statusText" class="claim-status">
          <dgx-components-icon
            [name]="'circle-dashed'"
            size="lg"
            class="claim-status__icon"
          ></dgx-components-icon>
          <p>{{ claimDisplayDetails.statusText | translate }}</p>
        </section>
        <section
          *ngIf="isRequestAction(calculatedAction)"
          class="request-action"
        >
          <dgx-components-button
            (clicked)="createClaim.emit()"
            data-testid="booking-start"
          >
            {{ claimDisplayDetails.actionText | translate }}
          </dgx-components-button>
        </section>

        <section
          *ngIf="isNonBookableProductType"
          class="non-booking-product-type"
        >
          <ng-container *ngTemplateOutlet="callUsContent"></ng-container>
        </section>

        <section
          *ngIf="
            (isSPToContactCustomerFlow ||
              claimDetails?.claimStatus === 'Repair booking needed') &&
            !claimDetails?.isTvRemoteReplacement
          "
          class="repair-needed"
        >
          <p class="typog-body">
            {{
              'MMR.SECTION.' + claimDetails?.claimType + '.REPAIR_NEEDED.line1'
                | translate
            }}
          </p>
          <p class="typog-body">
            {{
              'MMR.SECTION.' + claimDetails?.claimType + '.REPAIR_NEEDED.line2'
                | translate
            }}
          </p>
        </section>

        <section
          *ngIf="
            claimDetails?.isTvRemoteReplacement &&
            calculatedAction !== repairActionEnum.INCOMPLETE_FORM &&
            calculatedAction !== repairActionEnum.BOOK_ENGINEER &&
            calculatedAction !== serviceActionEnum.AMEND_SERVICE
          "
          class="replacement"
        >
          <p class="typog-body">
            {{ 'MMR.SECTION.REPAIR.TV_REPLACEMENT' | translate }}
          </p>
        </section>

        <section
          *ngIf="
            calculatedAction === repairActionEnum.IN_WAIT ||
            fullClaimsDetails.planInWaitPeriod
          "
          class="in-wait"
        >
          <p class="typog-body">
            {{ 'MMR.SECTION.' + claimType + '.WAIT.line1' | translate }}
          </p>
          <section class="in-wait__document">
            <p class="typog-body">
              {{ 'MMR.SECTION.' + claimType + '.WAIT.line2' | translate }}
            </p>
            <a
              class="link-section-link"
              (click)="!isDownloadingDocs && handleDownloadPlan()"
            >
              {{ 'MMR.SECTION.' + claimType + '.WAIT.line3' | translate }}
            </a>
            <dg-loader *ngIf="isDownloadingDocs"></dg-loader>
          </section>
        </section>

        <section
          *ngIf="
            calculatedAction === repairActionEnum.IN_WARRANTY &&
            !fullClaimsDetails.planInWaitPeriod
          "
          class="in-warranty"
        >
          <section class="in-warranty__heading">
            <p class="typog-body">
              {{ 'MMR.SECTION.REPAIR.WARRANTY.line1' | translate }}
            </p>
            <p class="typog-body">
              {{
                'MMR.SECTION.REPAIR.WARRANTY.line2'
                  | translate
                    : {
                        inWarrantyContactName:
                          claimDisplayDetails?.config?.inWarrantyContactName ??
                          formattedManufacturerString
                      }
              }}
            </p>
          </section>
          <ng-container *ngTemplateOutlet="phoneSection"></ng-container>
          <section>
            <p class="typog-caption-regular">
              {{ 'MMR.OWN_SYSTEM.OWN_SYSTEM_RATES_1' | translate }}
            </p>
            <p class="typog-caption-regular">
              {{ 'MMR.OWN_SYSTEM.OWN_SYSTEM_RATES_2' | translate }}
            </p>
          </section>
        </section>

        <section
          *ngIf="
            calculatedAction === repairActionEnum.DIRECT_REFERRAL_ONLY ||
            calculatedAction === repairActionEnum.DIRECT_CALL_CENTRE
          "
          class="direct-referral"
        >
          <section class="direct-referral-upper-wrapper">
            <section class="responsive-text-block">
              <p>
                {{
                  'MMR.OWN_SYSTEM.OWN_SYSTEM_1'
                    | translate : { manufacturer: formattedManufacturerString }
                }}
              </p>
              <p>
                {{
                  'MMR.OWN_SYSTEM.OWN_SYSTEM_2'
                    | translate : { manufacturer: formattedManufacturerString }
                }}
              </p>
            </section>
            <ng-container *ngTemplateOutlet="phoneSection"></ng-container>
            <section>
              <p class="typog-caption-regular">
                {{ 'MMR.OWN_SYSTEM.OWN_SYSTEM_RATES_1' | translate }}
              </p>
              <p class="typog-caption-regular">
                {{ 'MMR.OWN_SYSTEM.OWN_SYSTEM_RATES_2' | translate }}
              </p>
            </section>
          </section>
          <section
            *ngIf="directReferral.company_email"
            class="direct-referral-wrapper"
          >
            <p class="typog-body-bold">
              {{ 'MMR.OWN_SYSTEM.EMAIL' | translate }}
            </p>
            <section class="direct-referral-block">
              <dgx-components-icon
                [name]="'envelope'"
                size="md"
                class="direct-referral__icon"
              ></dgx-components-icon>
              <a [href]="'mailto:' + directReferral.company_email">
                {{ directReferral.company_email }}
              </a>
            </section>
          </section>
          <section
            *ngIf="isValidUrl(directReferral.company_website)"
            class="direct-referral-wrapper"
          >
            <p class="typog-body-bold">
              {{ 'MMR.OWN_SYSTEM.WEBSITE' | translate }}
            </p>
            <section class="direct-referral-block">
              <dgx-components-icon
                [name]="'mouse'"
                size="md"
                class="direct-referral__icon"
              ></dgx-components-icon>
              <a target="_blank" [href]="directReferral.company_website">
                {{ directReferral.company_website }}
              </a>
            </section>
          </section>
        </section>

        <section
          *ngIf="
            calculatedAction === repairActionEnum.INCOMPLETE_FORM ||
            calculatedAction === repairActionEnum.BOOK_ENGINEER ||
            calculatedAction === serviceActionEnum.AMEND_SERVICE
          "
          class="incomplete"
        >
          <dgx-components-button
            *ngIf="claimDetails?.cancelable"
            variant="secondary"
            (clicked)="cancelClaim.emit()"
            data-testid="booking-cancel"
          >
            {{ 'MMR.CANCEL' | translate }}
          </dgx-components-button>
          <dgx-components-button (clicked)="createClaim.emit()">
            {{ claimDisplayDetails.actionText | translate }}
          </dgx-components-button>
        </section>
      </section>
    </ng-container>

    <ng-container *ngIf="item.code === 'X7'">
      <section
        *ngIf="calculatedAction === 'IN_WAIT'; else callUs"
        class="in-wait"
      >
        <p class="typog-body">
          {{ 'MMR.SECTION.REPAIR.WAIT.line1' | translate }}
        </p>
        <p class="typog-body">
          {{ 'MMR.SECTION.REPAIR.WAIT.line2' | translate }}
        </p>
      </section>
    </ng-container>
  </ng-template>
</ng-container>

<ng-template #callUs>
  <section class="section-wrapper-neutral">
    <ng-container *ngTemplateOutlet="callUsContent"></ng-container>
  </section>
</ng-template>

<ng-template #callUsContent>
  <p class="typog-body">
    {{ 'MMR.SECTION.REPAIR.NON_BOOKING_PRODUCT_TYPE.line1' | translate }}
  </p>
  <ng-container *ngTemplateOutlet="phoneSection"></ng-container>
  <section>
    <p class="typog-caption-regular">
      {{ 'MMR.OWN_SYSTEM.OWN_SYSTEM_RATES_1' | translate }}
    </p>
    <p class="typog-caption-regular">
      {{ 'MMR.OWN_SYSTEM.OWN_SYSTEM_RATES_2' | translate }}
    </p>
  </section>
</ng-template>

<ng-container
  *ngIf="calculatedAction === repairActionEnum.REQUEST_REPAIR && isRPC"
>
  <section class="section-wrapper-neutral replacement">
    <section>
      <p>
        {{ 'MMR.REPLACEMENT.CONTENT' | translate }}
      </p>
    </section>
    <section class="item-list-wrapper">
      <p>
        {{ 'MMR.REPLACEMENT.LIST.HEADER' | translate }}
      </p>
      <ul class="item-list">
        <li>{{ 'MMR.REPLACEMENT.LIST.POINT1' | translate }}</li>
        <li>{{ 'MMR.REPLACEMENT.LIST.POINT2' | translate }}</li>
        <li>{{ 'MMR.REPLACEMENT.LIST.POINT3' | translate }}</li>
      </ul>
    </section>
  </section>
</ng-container>

<ng-template #phoneSection>
  <section *ngIf="!isMobile" class="phone-number link-with-icon desktop">
    <a
      *ngIf="callUsNumber"
      class="not-clickable-on-desktop"
      [phone]="callUsNumber | noSpaces"
    >
      <dgx-components-icon name="phone" size="sm"></dgx-components-icon>
      <span>{{ callUsNumber }}</span>
    </a>
  </section>
  <section *ngIf="isMobile" class="phone-number__mobile">
    <a *ngIf="callUsNumber" [phone]="callUsNumber | noSpaces">
      <dgx-components-button [iconName]="buttonIcon" [iconAlign]="'left'">
        {{ phoneButtonLabel }}
      </dgx-components-button>
    </a>
  </section>
</ng-template>
